module.exports = __webpack_public_path__ + "assets/img/tf.75e37b11.png";